// TMOS Setup Wizard - Welcome Step
// Date: December 19, 2025
// Purpose: Welcome step for setup wizard

import React from 'react';
import { useLanguage } from '@/state/language/LanguageProvider';

interface WelcomeStepProps {
  setupData: Record<string, any>;
  onComplete: (data: Record<string, any>) => void;
  onNext: () => void;
  loading: boolean;
}

export const WelcomeStep: React.FC<WelcomeStepProps> = ({
  onComplete,
  loading
}) => {
  const { t } = useLanguage();

  const handleContinue = () => {
    onComplete({ welcome_completed: true });
  };

  return (
    <div className="text-center py-8">
      <h2 className="text-2xl font-bold mb-4 text-gray-900">
        {t('setupWizard.welcome.title') || 'Welcome to TMOS Setup'}
      </h2>
      <p className="text-gray-600 mb-8 max-w-2xl mx-auto">
        {t('setupWizard.welcome.description') || 
          'We\'ll guide you through a few quick steps to get your account configured. This should only take a few minutes.'}
      </p>
      <button
        onClick={handleContinue}
        disabled={loading}
        className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50"
      >
        {t('setupWizard.welcome.getStarted') || 'Get Started'}
      </button>
    </div>
  );
};

